import { render, staticRenderFns } from "./EditReturned.vue?vue&type=template&id=c32eeef6&scoped=true&"
import script from "./EditReturned.vue?vue&type=script&lang=js&"
export * from "./EditReturned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32eeef6",
  null
  
)

export default component.exports